<template>
  <RF-Dialog
    :cpntStatus='statusGeral'
    :cpntLargura='"900px"'
    :cpntTitulo='"Signatários do Contrato " + $route.params.id'

    :cpntOnFecharDialog='contratosNumSigAdicionar'>
    <template slot="conteudo">
      <div style="margin: 10px 0px;">
        <table class="ctr-signatarios">
          <tr v-if="signPrincipal.length >= 1">
            <td colspan="5" style="padding: 0px">
              <div style="padding: 5px; text-align: center; font-weight: bold; background: #e9e9e9;">
                Signatário Principal
              </div>
            </td>
          </tr>
          <tr v-for="(signatario, index) in signPrincipal" :key="'tr-0-' + index">
            <td class="icone" style="text-align: center; width: 100px;">
              <RF-Icones
                :cpntId='signatario.icone.id'
                :cpntIcone='signatario.icone.icone'
                :cpntIconeClass='signatario.icone.class'
              ></RF-Icones>
              <div v-if="signatario.legendaIcone !== ''" style="font-size: var(--font-base-soma-12); padding: 5px 0px;" v-html="signatario.legendaIcone"></div>
            </td>
            <td>
              <label>Nome: </label>
              <span v-if="signatario.hasOwnProperty('buttonContato')">
                <RF-Button 
                  :cpntId='signatario.buttonContato.id'
                  :cpntStatus='signatario.buttonContato.status' 
                  :cpntTipo='signatario.buttonContato.tipo' 
                  :cpntTexto='signatario.buttonContato.texto' 
                  :cpntClass='signatario.buttonContato.class'
                  :cpntIcone='signatario.buttonContato.icone'
                  :cpntDisabled='signatario.buttonContato.disabled'
                  :cpntExplica='signatario.buttonContato.explica'

                  @onClickButton='signatario.buttonContato.onClick'
                ></RF-Button>
              </span>
              <span v-else v-html="signatario.nomeContato"></span>
              <br/>
              <label>E-mail: </label>
              <span v-html="signatario.email_ctr"></span>
            </td>
            <td style="text-align: center;">
              <label>Ação da assinatura: </label><br/>
              <span v-html="signatario.acao"></span>
            </td>
            <td class="ult-alteracao" style="text-align: center;">
              <label>Última Alteração: </label><br/>
              <span v-html="signatario.last_user_usuario + ' ' + signatario.last_at_ptbr"></span>
            </td>
            <td class="bts-acoes" style="text-align: center;" v-if="existeAcoes === true">
              <RF-Button v-if="signatario.key_signer !== '' && signatario.assinado === '' && signatario.hasOwnProperty('buttons') && signatario.buttons.length >= 1" v-for="(button, index) in signatario.buttons"
                :key="index"

                :cpntId='button.id'
                :cpntStatus='button.status' 
                :cpntTipo='button.tipo' 
                :cpntTexto='button.texto' 
                :cpntClass='button.class'
                :cpntIcone='button.icone'
                :cpntDisabled='button.disabled'
                :cpntExplica='button.explica'

                @onClickButton='button.onClick'
              ></RF-Button>
            </td>
          </tr>

          <tr v-if="signAdicional.length >= 1">
            <td colspan="5" style="padding: 0px">
              <div style="padding: 5px; text-align: center; font-weight: bold; background: #e9e9e9;">
                Signatários Adicionais
              </div>
            </td>
          </tr>
          <tr v-for="(signatario, index) in signAdicional" :key="'tr-1-' + index">
            <td class="icone" style="text-align: center; width: 100px;" >
              <RF-Icones
                :cpntId='signatario.icone.id'
                :cpntIcone='signatario.icone.icone'
                :cpntIconeClass='signatario.icone.class'
              ></RF-Icones>
              <div v-if="signatario.legendaIcone !== ''" style="font-size: var(--font-base-soma-12); padding: 5px 0px;" v-html="signatario.legendaIcone"></div>
            </td>
            <td class="sign-contato">
              <label>Nome: </label>
              <span v-if="signatario.key_signer !== '' && signatario.assinado === '' && signatario.hasOwnProperty('buttonContato')">
                <RF-Button 
                  :cpntId='signatario.buttonContato.id'
                  :cpntStatus='signatario.buttonContato.status' 
                  :cpntTipo='signatario.buttonContato.tipo' 
                  :cpntTexto='signatario.buttonContato.texto' 
                  :cpntClass='signatario.buttonContato.class'
                  :cpntIcone='signatario.buttonContato.icone'
                  :cpntDisabled='signatario.buttonContato.disabled'
                  :cpntExplica='signatario.buttonContato.explica'

                  @onClickButton='signatario.buttonContato.onClick'
                ></RF-Button>
              </span>
              <span v-else v-html="signatario.nomeContato"></span>
              <br/>
              <label>E-mail: </label>
              <span v-html="signatario.email_ctr"></span>
            </td>
            <td style="text-align: center;">
              <label>Ação da assinatura: </label><br/>
              <span v-html="signatario.acao"></span>
            </td>
            <td class="ult-alteracao" style="text-align: center;">
              <label>Última Alteração: </label><br/>
              <span v-html="signatario.last_user_usuario + ' ' + signatario.last_at_ptbr"></span>
            </td>
            <td class="bts-acoes" style="text-align: center;" v-if="existeAcoes === true">
              <RF-Button v-if="signatario.key_signer !== '' && signatario.assinado === '' && signatario.hasOwnProperty('buttons') && signatario.buttons.length >= 1" v-for="(button, index) in signatario.buttons"
                :key="index"

                :cpntId='button.id'
                :cpntStatus='button.status' 
                :cpntTipo='button.tipo' 
                :cpntTexto='button.texto' 
                :cpntClass='button.class'
                :cpntDisabled='button.disabled'
                :cpntIcone='button.icone'
                :cpntExplica='button.explica'

                @onClickButton='button.onClick'
              ></RF-Button>
            </td>
          </tr>
        </table>
      </div>

      <RF-Visualizar-Cadastro v-if="signatarioId !== null"
        :ref='"rf-contrato-info-contato-" + signatarioId'
        :cpntTipo='"contato"'

        :cpntButtonGeral='"Editar Contato"'
        :cpntButtons="[ 'editar', 'signatario' ]"
        :cpntMostraButton='true'
        :cpntRefId='signatarioId'
        :cpntRefButtonId='"rf-contrato-info-contato--" + signatarioId'

        :cpntFecharFormulario="function () { signatarioId = null }"
        :cpntOnAtualizaDados="contratosNumSigIniciar"
      ></RF-Visualizar-Cadastro>
    </template>
  </RF-Dialog>
</template>

<style scoped>
  .ctr-signatarios {
    width: 830px;
    margin: 0px auto;

    background: #fff;
    padding: 0px;
    height: auto;
    box-shadow: 0 2px 2px 0 rgba(0,0,0,.14), 0 3px 1px -2px rgba(0,0,0,.12), 0 1px 5px 0 rgba(0,0,0,.2);
    border-radius: 5px;
  }
    .ctr-signatarios > tr > td:first-child {
      border-top-right-radius: 5px;
      border-top-left-radius: 5px;
      border-left: 1px solid #dedede;
    }
    .ctr-signatarios > tr > td:last-child {
      border-bottom-right-radius: 5px;
      border-bottom-left-radius: 5px;
      border-right: 1px solid #dedede;
    }
    .ctr-signatarios > tr > td {
      border-top: 1px solid #dedede;
    }
    .ctr-signatarios > tr > td {
      border-bottom: 1px solid #dedede;
    }

    .ctr-signatarios > tr > td {
      text-align: left;
      padding: 10px;
    }
      .ctr-signatarios > tr > td > label {
        font-size: var(--font-base-soma-12);
      }
      .ctr-signatarios > tr > td > label ~ span {
        font-size: var(--font-base-soma-13);
        font-weight: 600;
      }

    .ctr-signatarios > tr > td.ult-alteracao {
      width: 125px;
      max-width: 125px;
    }
    .ctr-signatarios > tr > td.bts-acoes {
      text-align: center;
      width: 120px;
      max-width: 120px;
    }
      .ctr-signatarios > tr > td.bts-acoes > button {
        margin: 5px 0px;
        width: 100px;
      }
</style>

<style>
  .ctr-signatarios > tr > td:first-child > span > svg,
  .tabelaBuscaProdutoApi > div > table > tr:first-child > td:first-child > span > svg {
    font-size: var(--font-base-soma-40);
  }

  .ctr-signatarios > tr > td.bts-acoes > button > span > svg {
    vertical-align: -2px;
    font-size: var(--font-base-soma-20);
  }

  .ctr-signatarios > tr > td.sign-contato > span, .ctr-signatarios > tr > td.sign-contato > label {
    vertical-align: middle;
    margin: 0px;
  }

  .ctr-signatarios > tr > td.sign-contato > span {
    display: inline-block;
    max-width: 240px;
  }
  .ctr-signatarios > tr > td.sign-contato > span > button {
    max-width: 240px;
    display: inline-block;
    word-break: break-all;
  }
    .ctr-signatarios > tr > td.sign-contato > span > button > div {
      max-width: 300px;
      word-break: break-all;
      white-space: pre-wrap;
      text-align: left;
    }
</style>

<script>
  export default {
    components: {
      'RF-Visualizar-Cadastro': () => import('@/components/rf-geral/visualizar/Visualizar-Cadastro.vue')
    },
    data: function () {
      return {
        time: '',
        statusGeral: '',
        telaId: 'ctr_signatario',
        existeAcoes: false,
        signPrincipal: [],
        signAdicional: [],
        dadosContrato: {},
        signatarioId: null,
        acaoSignatarios: [
          { id: '1', nome: 'Assinar' },
          { id: '2', nome: 'Aprovar' },
          { id: '3', nome: 'Reconhecer' },
          { id: '4', nome: 'Assinar como parte' },
          { id: '5', nome: 'Assinar como testemunha' },
          { id: '6', nome: 'Assinar como interveniente' },
          { id: '7', nome: 'Acusar recebimento' },
          { id: '8', nome: 'Assinar como Emissor, Endossante e Avalista' }
        ]
      }
    },
    mounted: function () {
      this.contratosNumSigIniciar()
    },
    methods: {
      contratosNumSigIniciar: function () {
        // SETA O STATUS DA TELA
        this.statusGeral = 'carregando'

        // RESETA OS VALORES QUANDO REINICIADO
        this.signPrincipal = []
        this.signAdicional = []
        this.dadosContrato = []
        self.existeAcoes = false
        self.signatarioId = null

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // CHAMA A FUNÇÃO PARA CARREGAR OS DADOS
        this.contratosNumSigCarregarDadosContrato()
      },
      contratosNumSigCarregarDadosContrato: function () {
        var self = this

        var queryGet = { type: 'list', limit: { row: 0, qty: 1000 }, field: { id: null, status_processo: null, id_fase: null }, where: { f: 'id', o: '=', v: self.$route.params.id } }

        self.$store.state.comunicaAPI('/contrato/get/', 'GET', queryGet, function (apiSuccess) {
          // SETA OS VALORES RECEBIDOS DO CONTRATO
          self.dadosContrato = apiSuccess.data[0]

          // CHAMA A FUNÇÃO PARA CARREGAR OS DADOS
          self.contratosNumSigCarregarDadosSignatarios()
        }, function (apiError) {
          self.contratosNumSetaErroAPi(apiError)
        })
      },
      contratosNumSigCarregarDadosSignatarios: function () {
        var self = this

        var queryGet = { type: 'list', limit: { row: 0, qty: 1000 }, field: { id: null, id_ctr: null, id_con: { j: { nome: null, empresa: null, pessoa: null, status: null, email_ctr: null } }, last_at: null, last_user: { j: { usuario: null } }, f_principal: null, email_ctr: null, act: null, key_signer: null, assinado: null }, where: { f: 'id_ctr', o: '=', v: self.$route.params.id } }

        self.$store.state.comunicaAPI('/contrato/signatario/get/', 'GET', queryGet, function (apiSuccess) {
          var moment = require('moment')

          for (var key in apiSuccess.data) {
            // SETA O NOME DA AÇÃO QUE O SIGNATARIO VAI REALIZAR
            apiSuccess.data[key].acao = self.acaoSignatarios.filter(item => item.id === apiSuccess.data[key].act)[0].nome

            // SETA O ICONE
            apiSuccess.data[key].icone = {
              id: self.telaId + '-' + key,
              icone: 'alerta',
              class: [ 'rf-icon-amarelo' ]
            }

            apiSuccess.data[key].legendaIcone = ''
            if (apiSuccess.data[key].assinado !== '') {
              apiSuccess.data[key].legendaIcone = 'Assinado em ' + moment(apiSuccess.data[key].assinado, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm:ss')
              apiSuccess.data[key].icone.icone = 'check-circulo'
              apiSuccess.data[key].icone.class = [ 'rf-icon-verde' ]
            } else if (apiSuccess.data[key].key_signer === '') {
              apiSuccess.data[key].legendaIcone = 'Não Enviado'
            } else if (apiSuccess.data[key].key_signer !== '') {
              apiSuccess.data[key].legendaIcone = 'Não assinado'
              apiSuccess.data[key].icone.icone = 'erro'
              apiSuccess.data[key].icone.class = [ 'rf-icon-vermelho' ]
              self.existeAcoes = true
            }

            apiSuccess.data[key].nomeContato = apiSuccess.data[key].id_con_nome + ((apiSuccess.data[key].id_con_pessoa === 'j' && apiSuccess.data[key].id_con_empresa !== '') ? (' (' + apiSuccess.data[key].id_con_empresa + ')') : '') + (apiSuccess.data[key].id_con_status !== '1' ? ' <b>[Excluído]</b>' : '')

            if (self.dadosContrato.status_processo === '0' && [ '0', '1', '2', '4', '5', '6' ].indexOf(self.dadosContrato.id_fase) === -1) {
              apiSuccess.data[key].buttonContato = {
                id: self.telaId + '-bt-contato--' + apiSuccess.data[key].id_con,
                status: '',
                tipo: 'texto',
                texto: apiSuccess.data[key].nomeContato,
                class: [ 'btn', 'btn-default', 'btn-sm' ],
                disabled: false,
                onClick: function (id) {
                  self.signatarioId = id.split('--')[1]
                  // self.contratosNumSigAcaoApi('reenviar', id.split('--'))
                }
              }

              apiSuccess.data[key].hashId = (Math.floor(Math.random() * (9999 - 1000)) + 1000).toString()

              apiSuccess.data[key].buttons = [
                {
                  id: self.telaId + '-bt-reenviar--' + apiSuccess.data[key].hashId + '--' + apiSuccess.data[key].f_principal + '--0',
                  status: '',
                  tipo: 'texto',
                  texto: 'Reenviar',
                  class: [ 'btn', 'btn-default', 'btn-sm' ],
                  disabled: false,
                  onClick: function (id) {
                    self.contratosNumSigAcaoApi('reenviar', id.split('--'))
                  }
                },
                {
                  id: self.telaId + '-bt-atualizar--' + apiSuccess.data[key].hashId + '--' + apiSuccess.data[key].f_principal + '--1',
                  status: '',
                  tipo: (apiSuccess.data[key].email_ctr === apiSuccess.data[key].id_con_email_ctr ? 'texto' : 'icone-texto'),
                  texto: 'Atualizar',
                  icone: { tipo: 'alerta', id: self.telaId + '-bt-atualizar--' + apiSuccess.data[key].hashId + '--' + apiSuccess.data[key].f_principal + '--1-icone', class: 'rf-icon-amarelo' },
                  class: [ 'btn', 'btn-default', 'btn-sm' ],
                  disabled: apiSuccess.data[key].email_ctr === apiSuccess.data[key].id_con_email_ctr,
                  explica: ((apiSuccess.data[key].email_ctr === apiSuccess.data[key].id_con_email_ctr) ? { mensagem: '<div style="text-align: left; word-break: break-all;">O e-mail (' + apiSuccess.data[key].email_ctr + ') é o e-mail atual na D4Sign.</div>', positionMy: 'top right', positionAt: 'bottom left' } : { mensagem: '<div style="text-align: left; word-break: break-all;">Este e-mail (' + apiSuccess.data[key].email_ctr + ') está desatualizado na D4Sign.<br/><br/>Clique neste botão para atualizar o e-mail do signatário na D4Sign para o e-mail (' + apiSuccess.data[key].id_con_email_ctr + ').</div>', positionMy: 'bottom right', positionAt: 'top left' }),
                  onClick: function (id) {
                    self.contratosNumSigAcaoApi('atualizar', id.split('--'))
                  }
                }
              ]
            } else {
              self.existeAcoes = false
            }

            switch (apiSuccess.data[key].f_principal) {
              case 's':
                self.signPrincipal.push(apiSuccess.data[key])
                break

              case 'n':
                self.signAdicional.push(apiSuccess.data[key])
                break
            }
          }

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()

          // CHAMA A FUNÇÃO PARA FINALIZAR
          self.contratosNumSigFinalizar()
        }, function (apiError) {
          self.contratosNumSetaErroAPi(apiError)
        })
      },
      contratosNumSigFinalizar: function () {
        // SETA O STATUS DA TELA
        this.statusGeral = ''

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      contratosNumSigAcaoApi: function (tipo, registro) {
        var self = this

        var id = ''
        var router = ''
        var index = -1

        switch (registro[2]) {
          case 's':
            index = self.signPrincipal.findIndex(item => item.hashId === registro[1])

            if (index !== -1) {
              id = self.signPrincipal[index].id
              self.signPrincipal[index].buttons[registro[3]].status = 'carregando'
            }
            break

          case 'n':
            index = self.signAdicional.findIndex(item => item.hashId === registro[1])

            if (index !== -1) {
              id = self.signAdicional[index].id
              self.signAdicional[index].buttons[registro[3]].status = 'carregando'
            }
            break
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        self.time = new Date().getTime()

        if (id !== '') {
          // SETA O FORMULARIO QUE VAI SER ENVIADO PARA API
          var formData = { id: id }

          switch (tipo) {
            case 'reenviar':
              router = '/contrato/d4sign/reenviar-lnk-assinatura'
              break

            case 'atualizar':
              router = '/contrato/d4sign/signatario'
              break
          }

          self.$store.state.comunicaAPI(router, 'PUT', formData, function (apiSuccess) {
            self.$store.state.TRATAR_RET_LOT_API(apiSuccess, function () {
              // CHAMA A FUNÇÃO PARA REINICIAR
              self.contratosNumSigIniciar()
            })
          }, function (apiError) {
            self.contratosNumSetaErroAPi(apiError)
          }, function (apiValid, apiStatus) {
            for (var key in apiValid) {
              switch (apiStatus) {
                case '200':
                  self.$store.state.msgWarn('API [' + apiStatus + ']: ' + (typeof apiValid[key] === 'string' ? apiValid[key] : apiValid[key].join()), 'success')
                  break

                case '406':
                  self.$store.state.msgWarn('API [' + apiStatus + ']: ' + (typeof apiValid[key] === 'string' ? apiValid[key] : apiValid[key].join()), 'warning')
                  break

                case '409':
                default:
                  self.$store.state.msgWarn('API [' + apiStatus + ']: ' + (typeof apiValid[key] === 'string' ? apiValid[key] : apiValid[key].join()), 'danger')
                  break
              }
            }

            switch (registro[2]) {
              case 's':
                self.signPrincipal[index].buttons[registro[3]].status = ''
                break

              case 'n':
                self.signAdicional[index].buttons[registro[3]].status = ''
                break
            }

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()
          })
        }
      },
      contratosNumSigAdicionar: function () {
        this.$router.push({ name: 'contratos_gere' })
      }
    }
  }
</script>
